import React from 'react'
import SentPlanCron from './SentPlanCron'

const StatusField = (props) => {
  const { status, spanClassName = '', label = null, plan = {} } = props
  let statusClass
  switch (String(status).toLowerCase()) {
    case 'draft':
      statusClass = 'gray'
      break
    case 'sent':
      statusClass = 'error'
      break
    case 'scheduled':
      statusClass = 'primary'
      break
    case 'paid':
      statusClass = 'success'
      break
    case 'cancel':
      statusClass = '#000'
      break
    case 'resume':
      statusClass = 'secondary'
      break
    case 'pre application':
    case 'preapplication':
      statusClass = 'warning-alt'
      break
    case 'application':
      statusClass = 'inProgress'
      break
    case 'post application':
    case 'postapplication':
      statusClass = 'primary-alt'
      break
    case 'completed':
      statusClass = 'success-alt'
      break
    case 'finished':
      statusClass = '#9BE313'
      break
    case 'inprogress':
      statusClass = 'primary'
      break
    default:
      statusClass = 'secondary'
      break
  }
  const statusStyle = statusClass.startsWith('#') ? { backgroundColor: statusClass } : undefined
  const statusBadgeClass = statusClass.startsWith('#') ? '' : ` badge-${statusClass}`
  return (
    <>
      {['draft', 'sent'].includes(status?.toLowerCase()) && (<SentPlanCron plan={plan} className='mr-2' />)}
      <span style={{ textTransform: 'capitalize' }} className={`d-md-flex align-items-center font-weight-light justify-content-end ${spanClassName}`}>
        {label || (status === 'finished' ? 'Completed' : status)}
      </span>
      <span className={`mx-0 mr-2 mx-xl-0 ml-xl-2 ml-2 badge badge-pill point${statusBadgeClass}`} style={statusStyle}>
        &nbsp;
      </span>
    </>
  )
}

export default StatusField
